var _require = require('./breakpoints'),
  createBreakpoints = _require.createBreakpoints;
exports.createBreakpoints = createBreakpoints;